// src/lib/kb/answer.ts
import { supabase } from "@/lib/supabase";
import type { Audience, KbAnswerResponse, KbLane } from "./types";

export async function answerKbQuestion(input: {
  query: string;
  audience: Audience;
  locationId?: string | null;
  organizationId?: string | null;
  scopes?: string[] | null;
  topK?: number;
  minConfidence?: number;
  minSimilarity?: number; // deprecated alias
  lane: KbLane;
  laneOverride?: KbLane | null;
}): Promise<KbAnswerResponse> {
  const token = supabase ? (await supabase.auth.getSession()).data.session?.access_token : undefined;
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const resp = await fetch("/api/kb/answer", {
    method: "POST",
    headers,
    body: JSON.stringify(input),
  });

  const json = await resp.json().catch(() => ({}));

  if (!resp.ok) {
    const details =
      typeof (json as any)?.details === "string" ? (json as any).details : JSON.stringify(json);
    throw new Error(details || `KB answer failed (${resp.status})`);
  }

  return json as KbAnswerResponse;
}